import React from 'react';
import { useState, useEffect } from "react";
import { createLocalStore } from "@MyLib/System/LocalStorage.js";
import { MyInput, MyTextArea, MySelectBox, MyButton, MyEditableText, MyCheckBox } from './UI';
import { generateId } from "@MyLib/System/UniqueId.js";

const save = createLocalStore({root:"RestApi/"});

const API_BASE = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
	? 'http://127.0.0.1:5002' 
	: '';

const generateHeader = () => {
	return {
		Id: generateId(),
		Enabled: true,
		Key: "Content-Type",
		Value: "application/json",
	}
};

const MainPanel = ({project, api, onSave}) =>
{
	const methodList = [
		"GET",
		"POST",
	];
	
	const [method, setMethod] = useState("");
	const [url, setUrl] = useState("");
	const [requestBody, setRequestBody] = useState('');
	const [response, setResponse] = useState();
	const [responseText, setResponseText] = useState("");
	const [headers, setHeaders] = useState([generateHeader()]);

	const updateHeader = (id, field, value) => {
		setHeaders(prev =>
			prev.map(item =>
				item.Id === id
				? { ...item, [field]: value }
				: item
			)
		);
	};

	useEffect(() => {
		if (api)
		{
			setMethod(api.Method);
			setUrl(api.Url);
			console.log(api.Headers)
			setHeaders(api.Headers);
		}
	}, [api]);

	return (
		<div className="d-flex flex-column gap-3">
			{/* */}
			<div className="d-flex justify-content-between align-items-center">
				<nav aria-label="breadcrumb">
					<ol className="breadcrumb m-0">
						<li className="breadcrumb-item small">{project.Name}</li>
						<li className="breadcrumb-item active small" aria-current="page">
							<MyEditableText
								value={api.Name}
								onChange={(newText)=> {
									onSave({
										...api,
										Name: newText,
										Date: new Date().toISOString()
									});
								}}
							/>
						</li>
					</ol>
				</nav>
				<MyButton
					text="Save"
					onClick={()=>{
						onSave({
							...api,
							Method: method,
							Url: url,
							Date: new Date().toISOString()
						});
					}}
				/>
			</div>
			{/* リクエスト */}
			<div className="card">
				<div className="card-body">
					<div className="input-group mb-2">
						<MySelectBox
							itemList={methodList}
							value={method}
							onChange={(e) => {
								setMethod(e.target.value);
							}}
							style={{ maxWidth: '100px' }}
						/>
						<MyInput value={url} setValue={setUrl} />
						<MyButton
							text="Request"
							onClick={async () => {
								try {
									const requestHeaders = {};
									headers.forEach(item => {
										if (item.Enabled && item.Key) {
											requestHeaders[item.Key] = item.Value;
										}
									});
									console.log(url);
									console.log(method);
									console.log(requestHeaders);
									const res = await fetch(`${API_BASE}/rest-api/proxy`, {
										method: 'POST',
										headers: { 'Content-Type': 'application/json' },
										body: JSON.stringify({
											url: url,
											method: method,
											data: method !== 'GET' ? JSON.parse(requestBody || '{}') : null,
											//headers: { 'Accept': 'application/json' }
											headers: requestHeaders
										}),
									});
									setResponse(res);
									setResponseText(await res.text());
								}
								catch (err) {
									console.log(err);
									setResponse({ error: "送信失敗: " + err.message });
								}
							}}
						/>
					</div>
					<div className="mb-2">
						<div className="table-responsive">
							<table className="table table-sm table-bordered text-nowrap mb-0">
								<thead>
									<tr>
										<th style={{width: "30px"}}></th>
										<th style={{width: "25%"}}>Key</th>
										<th>Value</th>
										<th  style={{width: "60px"}}>
											<MyButton
												text="Add"
												onClick={()=>{
													setHeaders(prev => [
														...prev,
														generateHeader(),
													]);
												}}
											/>
										</th>
									</tr>
								</thead>
								<tbody>
									{headers && headers.map((item, index) => (
									<tr key={index}>
										<td>
											<MyCheckBox
												value={item.Enabled}
												setValue={(newValue) => {
													updateHeader(
														item.Id,
														"Enabled",
														newValue
													);
												}}
											/>
										</td>
										<td>
											<MyEditableText
												value={item.Key}
												onChange={(newText)=> {
													updateHeader(
														item.Id,
														"Key",
														newText
													);
												}}
												fullWidth={true}
											/>
										</td>
										<td>
											<MyEditableText
												value={item.Value}
												onChange={(newText)=> {
													updateHeader(
														item.Id,
														"Value",
														newText
													);
												}}
												fullWidth={true}
											/>
										</td>
										<td>
											<MyButton text="×"
												onClick={()=>{
													setHeaders(prev => prev.filter(item2 => item2.Id !== item.Id));
												}}
											/>
										</td>
									</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					<MyTextArea value={requestBody} setValue={setRequestBody} />
				</div>
			</div>
			{/* レスポンス */}
			<div className="d-flex flex-column gap-1">
				<div className="fw-bold">結果</div>
				<div>{responseText}</div>
			</div>
		</div>
	);
};

const defaultProjectInfo =
{
	Id: generateId(),
	Name: "Amazon",
	Date: "2026-01-01T00:00:00Z"
};

const generateApi = () => {
	return {
		Id: generateId(),
		Name: "Amazon",
		Url: "http://checkip.amazonaws.com",
		Method: "GET",
		Headers: [generateHeader()],
		Body: "",
	};
};

const defaultSaveData =
{
	ProjectInfoList: [
		defaultProjectInfo
	],
	ProjectDataList: [
		{
			Id: defaultProjectInfo.Id,
			ApiList: [
				generateApi()
			]
		}
	]
};

export const RestApiApp = () =>
{
	const [localData, setLocalData] = useState(() => {return save.loadJson("SaveData") ?? defaultSaveData});
	const projectInfoList = localData.ProjectInfoList;
	const projectDataList = localData.ProjectDataList;

	const [sideProjectId, setSideProjectId] = useState("");
	const projectInfoSide = projectInfoList.find(item => item.Id === sideProjectId);
	const projectDataSide = projectDataList.find(item => item.Id === sideProjectId);

	const [targetProjectId, setTargetProjectId] = useState("");
	const targetProjectInfo = projectInfoList.find(item => item.Id === targetProjectId);
	const targetProjectData = projectDataList.find(item => item.Id === targetProjectId);
	const [targetApi, setTargetApi] = useState(null);

	useEffect(() => {
		if (localData)
		{
			console.log(localData);
			save.saveJson("SaveData", localData);
		}
	}, [localData]);

	const addProject = () => {
		const name = prompt("プロジェクト名を入力してください", "新プロジェクト");
		if (!name) {
			return;
		}
		const projectId = generateId();
		const newSaveData = {
			ProjectInfoList: [...projectInfoList, {
				Id: projectId,
				Name: name,
				Date: new Date().toISOString()
			}],
			ProjectDataList: [...projectDataList, {
				Id: projectId,
				ApiList: []
			}]
		};
		setLocalData(newSaveData);
	};
	const removeProject = (project) => {
		if (!confirm("本当に削除しますか？")) {
			return;
		}
		const newSaveData = {
			ProjectInfoList: projectInfoList.filter(item => item.Id !== project.Id),
			ProjectDataList: projectDataList.filter(item => item.Id !== project.Id)
		};
		setLocalData(newSaveData);
	};
	const updateProjectData = (newProjectData) => {
		const newProjectDataList = projectDataList.map((item) => {
			return (item.Id === newProjectData.Id) ? newProjectData : item;
		});
		const newSaveData = {
			...localData,
			ProjectDataList: newProjectDataList
		};
		setLocalData(newSaveData);
	};

	const addApi = () => {
		const name = prompt("API名を入力してください", "新API");
		if (!name) {
			return;
		}
		const newApi = {
			...generateApi(),
			Name: name,
			Date: new Date().toISOString()
		};
		const newProjectData = {
			...projectDataSide,
			ApiList: [...projectDataSide.ApiList, newApi]
		};
		updateProjectData(newProjectData);
	};
	const removeApi = (api) => {
		if (!confirm("本当に削除しますか？")) {
			return;
		}
		const newProjectData = {
			...projectDataSide,
			ApiList: projectDataSide.ApiList.filter(item => item.Id !== api.Id)
		};
		updateProjectData(newProjectData);
	};
	const updateApi = (newApi) => {
		const newProjectData = {
			...targetProjectData,
			ApiList: targetProjectData.ApiList.map((item) => {
				if (item.Id === newApi.Id) {
					return newApi;
				}
				return item;
			})
		};
		updateProjectData(newProjectData);
		setTargetApi(newApi);
	};

	return (
		<div className="container-fluid d-flex flex-column">
			<header className="row py-1 bg-dark-subtle">
				<div className="col d-flex gap-2">
					<h5 className="m-0">My REST Client <small className="text-muted">v1.0</small></h5>
					<MyButton
						text="Save WorkSpace"
						onClick={()=>{
							if (projectInfoSide == null || projectDataSide == null) {
								return;
							}
							const data = {
								Info: projectInfoSide,
								Data: projectDataSide,
							};
							const json = JSON.stringify(data, null, '\t');
							const blob = new Blob([json], { type: 'application/json' });
							const url = URL.createObjectURL(blob);
							const a = document.createElement('a');
							a.href = url;
							a.download = `${projectInfoSide.Name}.json`;
							a.click();
							URL.revokeObjectURL(url);
						}}
					/>
					<MyButton
						text="Load WorkSpace"
						onClick={async ()=>{
							return new Promise((resolve, reject) => {
								const input = document.createElement('input');
								input.type = 'file';
								input.accept = '.json';
								input.onchange = e => {
									const file = e.target.files[0];
									if (!file) {
										return;
									}
									const reader = new FileReader();
									reader.onload = e => {
										const data = JSON.parse(e.target.result);
										try {
											const data = JSON.parse(e.target.result);
											
											const projectId = generateId();
											const newSaveData = {
												ProjectInfoList: [...projectInfoList, {
													...data.Info,
													Id: projectId,
													Date: new Date().toISOString()
												}],
												ProjectDataList: [...projectDataList, {
													...data.Data,
													Id: projectId,
												}]
											};
											setLocalData(newSaveData);

											resolve(data);
										} catch (err) {
											reject(new Error("JSONのパースに失敗しました"));
										}
									};
									reader.onerror = () => reject(new Error("ファイルの読み込みに失敗しました"));
									reader.readAsText(file);
								};
								input.oncancel = () => {
									resolve(null); // rejectではなくresolve(null)にすると、エラーにならずに「なし」として扱える
								};
								input.click();
							});
						}}
					/>
				</div>
			</header>
			<div className="row flex-grow-1 overflow-hidden">
				{/* 左 */}
				<nav
					className="col-md-3 col-lg-2 p-0 overflow-auto"
				>
					<div className="p-1 d-flex justify-content-between align-items-center">
						<div className="fw-bold">Workspaces</div>
						<MyButton outline={true} text="+" onClick={addProject} />
					</div>
					<div className="accordion accordion-flush" id="projectAccordion">
						{projectInfoList.map((project) => (
							<div className="accordion-item" key={project.Id}>
								<div className="accordion-header">
									<div 
										className={`accordion-button ${project.Id !== sideProjectId ? 'collapsed' : ''}`}
										type="button"
										onClick={() => setSideProjectId(project.Id)}
									>
										<div
											className='d-flex align-items-center flex-grow-1 pe-2'
										>
											{project.Name}
											<MyButton
												className="ms-auto"
												text="×"
												onClick={(e)=>{
													e.stopPropagation();
													removeProject(project);
												}}
											/>
										</div>
									</div>
								</div>
								<div className={`accordion-collapse collapse ${project.Id === sideProjectId ? 'show' : ''}`}>
									<div className="accordion-body p-0">
										<div className="list-group list-group-flush">
											{projectDataSide?.ApiList.map(api => (
												<div
													key={api.Id}
													className="list-group-item list-group-item-action small d-flex align-items-center gap-2"
													onClick={() => {
														setTargetProjectId(sideProjectId);
														setTargetApi(api);
													}}
												>
													<div className={`badge ${api.Method === 'GET' ? 'bg-success' : 'bg-warning'}`}>
														{api.Method}
													</div>
													<div>
														{api.Name}
													</div>
													<MyButton
														className="ms-auto"
														text="×"
														onClick={(e)=>{
															e.stopPropagation();
															removeApi(api);
														}}
													/>
												</div>
											))}
											<button
												className="list-group-item list-group-item-action ps-4 text-primary small"
												onClick={addApi}
											>
												+ Add Request
											</button>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</nav>
				{/* 右 */}
				<div className="col-md-9 col-lg-10 p-4 overflow-auto bg-white">
					{(targetProjectInfo && targetApi) &&
						<MainPanel project={targetProjectInfo} api={targetApi} onSave={updateApi} />
					}
				</div>
			</div>
		</div>
	);
};
